import service from './service'
export function initWx (image, description) {
  const ua = window.navigator.userAgent
  const isWechat = /micromessenger/i.test(ua)
  if (!isWechat) {
    return
  }
  const url = window.location.href.split('#')[0]
  service.get(`/jssdk/sign?url=${encodeURIComponent(url)}`).then((res) => {
    window.wx.config({
      debug: false,
      nonceStr: res.noncestr,
      signature: res.sign,
      timestamp: res.timestamp,
      appId: res.appid,
      jsApiList: [
        'updateTimelineShareData',
        'updateAppMessageShareData'
      ]
    })
    window.wx.ready(() => {
      window.wx.updateTimelineShareData({
        title: document.title, // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: `${image}?imageView2/1/w/200/h/200`, // 分享图标
        success: () => {
          // 用户点击了分享后执行的回调函数
          window.gtag('event', 'share', {
            method: 'weixin'
          })
        }
      })
      window.wx.updateAppMessageShareData({
        title: document.title, // 分享标题
        desc: description, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: `${image}?imageView2/1/w/200/h/200`, // 分享图标
        success: () => {
          // 用户点击了分享后执行的回调函数
          window.gtag('event', 'share', {
            method: 'weixin'
          })
        }
      })
    })
    window.wx.error(() => {
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      // console.log(error)
    })
  })
}